import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=14b4f9fc&scoped=true&"
import script from "./CompaniesList.vue?vue&type=script&lang=ts&"
export * from "./CompaniesList.vue?vue&type=script&lang=ts&"
import style0 from "./CompaniesList.vue?vue&type=style&index=0&id=14b4f9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b4f9fc",
  null
  
)

export default component.exports